import React, { useState } from 'react'
import RetailersList from '../../components/retailers/RetailersList'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import PageTitle from '../../components/common/PageTitle'
import Pagination from '../../components/common/Pagination'
import SeoHelmet from '../../components/common/SeoHelmet'
import USER_TYPE from '../../constants/userType'
import TopShopSection from '../../components/retailers/TopShopSection'

const RetailersPage = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const { data: retailersData } = useQuery({
    queryKey: QueryKeys.retailersList(currentPage),
    queryFn: () => handleGetRequest('/retailers', { page: currentPage }),
  })

  const retailers = retailersData?.data || []

  return (
    <div className="main-container">
      <SeoHelmet
        title="Browse Retailers"
        description="Discover top retailers in Eastleigh marketplace. Find verified shops offering quality products with competitive prices. Connect directly with trusted retail partners."
        keywords="Eastleigh retailers, verified shops, retail marketplace, Kenya retailers, online shopping, Sokooni retailers"
        url="/retailers"
      />
      <PageTitle>Retailers</PageTitle>
      <TopShopSection userType={USER_TYPE.retailer} title="Top Retailer Shops" />
      <div className="mt-6">
        <section>
          <RetailersList retailers={retailers} />
        </section>
        <Pagination paginationMeta={retailersData?.meta} onPageChange={setCurrentPage} />
      </div>
    </div>
  )
}

export default RetailersPage
